import en from '../../../components/i18nProvider/en';
import { Iprefix } from '../../../hooks/useTranslation';

const translatePrefix: Iprefix = 'programAgentWallet';

export const getTabTranslatePrefix = (tab: keyof (typeof en)['programAgentWallet']) =>
  (translatePrefix + '.' + tab) as Iprefix;
